export const portfolioData = {
  personal: {
    name: "Babacar Diagne",
    nickname: "dbeeb96",
    role: "Ingénieur Logiciel Full Stack",
    subtitles: [
      "Ingénieur Logiciel Full Stack",
      "Lead Tech & Co-fondateur AppliCodeTech",
      "Expert Java, Spring Boot & React",
      "Enseignant en Génie Informatique (UKB)",
      "Architecte Systèmes & Cloud OVH / AWS"
    ],
    email: "dbeeb96@gmail.com",
    phone: "+221 77 349 03 18",
    phoneDisplay: "+221 77 349 03 18",
    phoneAlternative: "+221 70 980 89 60",
    location: "Rao, Saint-Louis, Sénégal",
    github: "https://github.com/dbeeb96",
    linkedin: "https://www.linkedin.com/in/babacar-diagne",
    sololearn: "https://www.sololearn.com/fr/profile/16888356",
    cvPdf: "/CV-BABACAR-DIAGNE-2026.pdf",
    status: "Disponible pour nouveaux projets & consultations Lead Tech",
    stats: [
      { value: "3+", label: "Années d'expérience", icon: "fa-solid fa-code" },
      { value: "10+", label: "Projets livrés & actifs", icon: "fa-solid fa-rocket" },
      { value: "100%", label: "Engagement qualité", icon: "fa-solid fa-shield-halved" },
      { value: "200+", label: "Étudiants & devs formés", icon: "fa-solid fa-user-graduate" }
    ],
    bio: "Ingénieur logiciel diplômé de Master 2 en Ingénierie Logicielle (UNCHK) et cofondateur de la startup AppliCodeTech. Fort d'une expertise pointue dans l'écosystème Java/Spring Boot, React, Angular et le Cloud, je conçois et déploie des architectures logicielles modernes, robustes et à fort impact. Passionné par l'innovation technologique, je combine excellence technique, vision entrepreneuriale et transmission du savoir à l'Université Kocc Barma de Saint-Louis."
  },

  skills: [
    // Backend & Architecture
    { name: "Java", category: "backend", level: 92, icon: "fa-brands fa-java", color: "#F89820", tag: "Expert Core Java" },
    { name: "Spring Boot", category: "backend", level: 90, icon: "fa-solid fa-leaf", color: "#6DB33F", tag: "Microservices & REST" },
    { name: "Spring Security", category: "backend", level: 85, icon: "fa-solid fa-lock", color: "#10B981", tag: "JWT & OAuth2" },
    { name: "PHP / Symfony", category: "backend", level: 75, icon: "fa-brands fa-php", color: "#777BB4", tag: "MVC & CMS" },
    { name: "Node.js / Express", category: "backend", level: 78, icon: "fa-brands fa-node-js", color: "#339933", tag: "APIs temps réel" },
    
    // Frontend
    { name: "React.js", category: "frontend", level: 88, icon: "fa-brands fa-react", color: "#61DAFB", tag: "Hooks & SPA Modernes" },
    { name: "Angular", category: "frontend", level: 78, icon: "fa-brands fa-angular", color: "#DD0031", tag: "TypeScript & Components" },
    { name: "JavaScript (ES6+)", category: "frontend", level: 90, icon: "fa-brands fa-js", color: "#F7DF1E", tag: "Modern Async & DOM" },
    { name: "HTML5 / CSS3 / SCSS", category: "frontend", level: 95, icon: "fa-brands fa-html5", color: "#E34F26", tag: "Responsive & Flexbox" },
    { name: "Bootstrap 5 & Tailwind", category: "frontend", level: 92, icon: "fa-brands fa-bootstrap", color: "#7952B3", tag: "UI Cyber & Chic" },

    // Database & Cloud
    { name: "MySQL", category: "cloud", level: 88, icon: "fa-solid fa-database", color: "#4479A1", tag: "Modélisation & Optimisation" },
    { name: "PostgreSQL", category: "cloud", level: 82, icon: "fa-solid fa-server", color: "#336791", tag: "Requêtes complexes" },
    { name: "Cloud AWS", category: "cloud", level: 78, icon: "fa-brands fa-aws", color: "#FF9900", tag: "EC2, S3, Déploiements" },
    { name: "Docker & Conteneurs", category: "cloud", level: 75, icon: "fa-brands fa-docker", color: "#2496ED", tag: "Virtualisation & Env" },
    { name: "CI/CD (Jenkins / Actions)", category: "cloud", level: 76, icon: "fa-solid fa-gears", color: "#D24939", tag: "Pipelines automatisés" },
    { name: "Linux / VPS OVH", category: "cloud", level: 85, icon: "fa-brands fa-linux", color: "#FCC624", tag: "Administration serveur" },

    // UI/UX & Tools
    { name: "Figma & Adobe XD", category: "design", level: 82, icon: "fa-brands fa-figma", color: "#F24E1E", tag: "Prototypage & Wireframes" },
    { name: "Photoshop & Illustrator", category: "design", level: 88, icon: "fa-solid fa-palette", color: "#31A8FF", tag: "Infographie & Chartes" },
    { name: "Moodle & LMS", category: "tools", level: 92, icon: "fa-solid fa-graduation-cap", color: "#F98012", tag: "E-learning & Sécurité" },
    { name: "WordPress & CMS", category: "tools", level: 90, icon: "fa-brands fa-wordpress", color: "#21759B", tag: "Portails sur mesure" },
    { name: "Git / GitHub / Bitbucket", category: "tools", level: 92, icon: "fa-brands fa-git-alt", color: "#F05032", tag: "Collaboration & DevOps" }
  ],

  projects: [
    {
      id: "dpc",
      title: "DPC — Direction de la Pêche Continentale",
      category: "production",
      categoryLabel: "Portail Officiel Étatique",
      image: "/assets/projects/project-dpc.png",
      rawImage: "/1679838387670.jpeg",
      status: "En Ligne",
      statusColor: "#00F59B",
      link: "https://dpc.gouv.sn/",
      description: "Conception, architecture et mise en production du portail web officiel de la Direction de la Pêche Continentale du Sénégal pour la valorisation et la digitalisation des services de la pêche.",
      longDescription: "Mandaté au sein de AppliCodeTech, j'ai supervisé l'architecture technique, le design et le déploiement du site officiel de la Direction de la Pêche Continentale. La plateforme offre une interface moderne, sécurisée, adaptée aux normes de l'administration sénégalaise et aux exigences de haute disponibilité.",
      tags: ["CMS Avancé", "Sécurité Web", "Architecture Web", "SEO", "Responsive UI"],
      highlights: [
        "Portail officiel de l'État sénégalais (gouv.sn)",
        "Design institutionnel moderne et conforme aux standards",
        "Performances optimisées et sécurité durcie"
      ]
    },
    {
      id: "sgep-ukb",
      title: "SGEP — Université Kocc Barma (UKB)",
      category: "production",
      categoryLabel: "Système de Gestion d'Établissement",
      image: "/assets/projects/project-sgep.png",
      rawImage: "/analyses-daudience-internet.png",
      status: "En Production",
      statusColor: "#00F59B",
      link: "https://vps-d463d072.vps.ovh.net/",
      description: "Système d'Information complet (ERP Scolarité) de l'Université Kocc Barma de Saint-Louis : gestion des inscriptions, notes, emplois du temps et pilotage académique.",
      longDescription: "Conception et mise en œuvre intégrale de l'ERP universitaire SGEP. L'outil centralise la gestion des départements, des étudiants, du corps professoral, des relevés de notes et de l'assurance qualité (CIAQ), hébergé sur une infrastructure cloud VPS OVH hautement sécurisée.",
      tags: ["ERP Universitaire", "Java", "Bases de Données", "Cloud OVH", "Architecture RBAC"],
      highlights: [
        "Utilisé quotidiennement par le corps enseignant et administratif",
        "Gestion automatisée des notes, filières et emplois du temps",
        "Déploiement sur serveur VPS OVH avec monitoring"
      ]
    },
    {
      id: "nautica",
      title: "NauticaSenegal 2.0 — Surveillance Maritime",
      category: "critical",
      categoryLabel: "Système Maritime & R&D",
      image: "/assets/projects/project-nautica.png",
      rawImage: "/WhatsApp Image 2024-12-27 at 3.30.26 PM.jpeg",
      status: "Système Avancé",
      statusColor: "#00E5FF",
      description: "Système intelligent de détection, pistage et géolocalisation des embarcations dans les eaux côtières sénégalaises pour prévenir les activités illicites et suspectes.",
      longDescription: "Projet de pointe à impact stratégique : NauticaSenegal 2.0 combine technologies de géolocalisation, traitement de flux de données maritimes et télédétection pour sécuriser le littoral sénégalais et fournir des alertes précoces en temps réel aux autorités maritimes.",
      tags: ["Télédétection", "Géolocalisation", "Algorithmique", "Data Stream", "Sécurité Côtière"],
      highlights: [
        "Détection précoce d'embarcations suspectes",
        "Tableau de bord de suivi cartographique temps réel",
        "Algorithmes d'alerte et surveillance côtière"
      ]
    },
    {
      id: "sgst-pied",
      title: "SGST-PIED — Pôle Innovation UNCHK",
      category: "research",
      categoryLabel: "R&D Master & Collaboration",
      image: "/assets/projects/project-sgst.png",
      rawImage: "/gestion-de-donnees.png",
      status: "Terminé avec succès",
      statusColor: "#8B5CF6",
      description: "Système de Gestion et Suivi des Tâches au niveau du Pôle d'Innovation et d'Expertise pour le Développement de l'UNCHK (PIED). Projet d'excellence Master.",
      longDescription: "Réalisé dans le cadre de mon Master 2 en Ingénierie Logicielle, SGST-PIED répond aux besoins de collaboration et de gouvernance du pôle PIED. Il intègre une architecture RESTful Spring Boot, Spring Security, un pipeline CI/CD Jenkins/SonarQube et un déploiement cloud AWS.",
      tags: ["Spring Boot", "Spring Security", "AWS Cloud", "Jenkins CI/CD", "SonarQube", "Postman"],
      highlights: [
        "Architecture robuste sécurisée par tokens & RBAC",
        "Pipeline DevOps automatisé de tests et analyse statique",
        "Déploiement en production sur AWS"
      ]
    },
    {
      id: "applicodetech",
      title: "AppliCodeTech — Startup IT",
      category: "startup",
      categoryLabel: "Entrepreneuriat & Innovation",
      image: "/assets/projects/project-applicodetech.png",
      rawImage: "/vec-act.png",
      status: "Startup Active",
      statusColor: "#00F59B",
      description: "Co-fondation et direction technique d'une entreprise innovante dédiée à la conception de logiciels sur mesure, d'applications web/mobiles et à la transformation digitale.",
      longDescription: "En tant que co-fondateur et Lead Développeur d'AppliCodeTech, je pilote les équipes techniques, la R&D produit, la relation client et l'architecture des solutions délivrées tant aux organismes publics qu'au secteur privé.",
      tags: ["Startup", "Leadership Tech", "Full Stack", "Consulting IT", "Architecture"],
      highlights: [
        "Plusieurs plateformes d'envergure livrées",
        "Offre complète de développement web, mobile et cloud",
        "Équipe pluridisciplinaire d'ingénieurs passionnés"
      ]
    },
    {
      id: "sanaragro",
      title: "SanarAgro Platform",
      category: "startup",
      categoryLabel: "AgriTech & E-Commerce",
      image: "/assets/projects/project-sanaragro.png",
      rawImage: "/site.png",
      status: "En Ligne",
      statusColor: "#00F59B",
      link: "https://sanaragro.sn/",
      description: "Plateforme digitale agropastorale pour la valorisation des filières agricoles locales et la commercialisation de produits du terroir sénégalais.",
      longDescription: "Conception complète de la boutique et de la plateforme technologique SanarAgro, facilitant les échanges entre producteurs locaux et acheteurs avec un design attractif, réactif et optimisé pour le mobile.",
      tags: ["AgriTech", "E-Commerce", "UI/UX", "SEO", "Paiements Numériques"],
      highlights: [
        "Digitalisation de la filière agricole de Saint-Louis",
        "Interface responsive intuitive adaptée aux utilisateurs",
        "Plateforme performante et sécurisée"
      ]
    },
    {
      id: "senegal-academy",
      title: "Senegal Academy & Vasy LMS (Partenariat GIZ)",
      category: "production",
      categoryLabel: "E-Learning & Partenariat International",
      image: "/assets/projects/project-applicodetech.png",
      rawImage: "/analyses-daudience-internet.png",
      status: "Terminé",
      statusColor: "#00F59B",
      link: "https://senegalacademy.sn",
      description: "Refonte du portail Senegal Academy et déploiement de la plateforme e-learning Vasy (vasy.sn) en collaboration avec Plan Saint-Louis et la GIZ.",
      longDescription: "Pilotage technique de la plateforme e-learning Moodle sécurisée (vasy.sn) et conseiller technique sur le projet Ndar Digi PME financé par la coopération allemande GIZ pour la mise en place d'un progiciel ERP destiné aux PME locales.",
      tags: ["Moodle LMS", "GIZ Partenariat", "Sécurité Web", "ERP", "WordPress"],
      highlights: [
        "Plateforme LMS ayant formé des centaines d'apprenants",
        "Sécurisation avancée et conformité des plugins",
        "Projet Ndar Digi PME en synergie avec la GIZ"
      ]
    }
  ],

  experiences: [
    {
      role: "Cofondateur & Lead Développeur Full Stack",
      company: "AppliCodeTech (Startup IT)",
      location: "Sénégal",
      period: "Janvier 2024 – Présent",
      current: true,
      description: "Pilotage stratégique et technique des développements logiciels de la startup. Architecture de plateformes pour l'État (DPC) et le secteur privé (SanarAgro, NauticaSenegal).",
      tasks: [
        "Architecture logicielle et supervision technique des projets web & mobiles",
        "Création et mise en ligne du site officiel de la Direction de la Pêche Continentale (dpc.gouv.sn)",
        "Conception de la plateforme e-commerce agricole SanarAgro (sanaragro.sn)",
        "R&D sur le système de détection maritime côtière NauticaSenegal 2.0"
      ],
      tech: "Java, Spring Boot, React, MySQL, OVH VPS, Architecture Microservices"
    },
    {
      role: "Ingénieur Logiciel & Responsable CIAQ, Enseignant",
      company: "Université Kocc Barma (UKB) de Saint-Louis",
      location: "Saint-Louis, Sénégal",
      period: "Octobre 2024 – Présent",
      current: true,
      description: "Conception du système de gestion des étudiants (SGEP), administration système et enseignement des matières fondamentales en génie informatique.",
      tasks: [
        "Conception et mise en production de l'ERP de scolarité universitaire SGEP (vps-d463d072.vps.ovh.net)",
        "Administration de l'infrastructure réseau, serveurs et maintenance du parc informatique",
        "Enseignement des cours d'Algorithmique et Programmation en Licence 1 Génie Informatique (LGI1)",
        "Chargé de cours en Projet Opérationnel en Licence 3 Génie Informatique (LGI3)",
        "Responsable de la Cellule Interne d'Assurance Qualité (CIAQ)"
      ],
      tech: "Java, Systèmes d'Information, Algorithmique, Cloud OVH, Pédagogie IT"
    },
    {
      role: "Chef de Projet Web & Développeur Full Stack",
      company: "Senegal Academy | TechnofuturGroup (SA | TFG)",
      location: "Saint-Louis, Sénégal",
      period: "Décembre 2022 – Juin 2023",
      current: false,
      description: "Gestion des projets web, refonte du portail institutionnel et implémentation de plateformes LMS e-learning en partenariat avec des ONG et la GIZ.",
      tasks: [
        "Refonte intégrale et optimisation du site https://senegalacademy.sn",
        "Chef de projet technique pour la mise en place de la plateforme e-learning Vasy (vasy.sn)",
        "Installation, sécurisation et déploiement de l'environnement LMS Moodle",
        "Conseiller technique sur le projet Ndar Digi PME en partenariat avec la GIZ (mise en œuvre d'ERP)"
      ],
      tech: "Moodle, PHP, CMS WordPress, Linux, Sécurité Web, Gestion de projet Agile"
    },
    {
      role: "Ingénieur Projet Master R&D",
      company: "Pôle PIED — Université Numérique Cheikh Hamidou Kane (UNCHK)",
      location: "Dakar / Saint-Louis, Sénégal",
      period: "Septembre 2022 – Juillet 2023",
      current: false,
      description: "Développement d'un système collaboratif de suivi des activités et indicateurs de performance du pôle d'expertise PIED.",
      tasks: [
        "Analyse du besoin, modélisation UML et conception du tableau de bord SGST-PIED",
        "Développement de l'API RESTful avec Spring Boot et Spring Security",
        "Intégration d'un pipeline DevOps avec Jenkins et SonarQube pour l'analyse de qualité",
        "Déploiement sur l'infrastructure Cloud AWS et validation des tests avec Postman"
      ],
      tech: "Java, Spring Boot, Spring Security, AWS, Jenkins, SonarQube, Postman"
    }
  ],

  education: [
    {
      degree: "Master 2 en Ingénierie Logicielle (IL)",
      institution: "Université Numérique Cheikh Hamidou Kane (UNCHK)",
      period: "2022 – 2024",
      location: "Sénégal",
      description: "Spécialisation avancée en génie logiciel, architecture des systèmes distribués, sécurité applicative, cloud computing et gestion de projets agiles.",
      icon: "fa-solid fa-graduation-cap"
    },
    {
      degree: "Licence en Mathématiques Appliquées & Informatique (MAI)",
      institution: "Université Numérique Cheikh Hamidou Kane (UNCHK)",
      period: "2019 – 2020",
      location: "Sénégal",
      description: "Fondements solides en algorithmique, structures de données, programmation système, calcul scientifique et bases de données relationnelles.",
      icon: "fa-solid fa-square-root-variable"
    },
    {
      degree: "Formation Professionnelle en Infographie & Design",
      institution: "Institut des Métiers et Sciences Appliquées du Sénégal (IMSAS)",
      period: "2020 – 2021",
      location: "Sénégal",
      description: "Création graphique publicitaire, chartes visuelles d'entreprise, identité numérique, retouche et vectorisation avancée (Photoshop, Illustrator).",
      icon: "fa-solid fa-bezier-curve"
    },
    {
      degree: "Formation Certifiante Développeur Web",
      institution: "SIMPLON Dakar",
      period: "2019 – 2020",
      location: "Dakar, Sénégal",
      description: "Formation intensive en pédagogie active axée sur le développement web moderne, les architectures MVC, JavaScript, HTML5/CSS3 et le travail collaboratif.",
      icon: "fa-solid fa-laptop-code"
    },
    {
      degree: "Baccalauréat Scientifique (Série S2 - Sciences Expérimentales)",
      institution: "Lycée de SOUM",
      period: "2016 – 2017",
      location: "Fatick, Sénégal",
      description: "Baccalauréat scientifique avec solides compétences en mathématiques appliquées, physique-chimie et sciences fondamentales.",
      icon: "fa-solid fa-atom"
    }
  ],

  references: [
    {
      name: "Abdoulaye DIOP",
      title: "Directeur Exécutif de Senegal Academy",
      phone: "+221 77 614 65 84",
      relation: "Collaboration sur Senegal Academy, Plateforme Vasy et projet GIZ"
    },
    {
      name: "Pr. Ousmane SALL",
      title: "Vice-Recteur de l’Université Numérique Cheikh Hamidou Kane (UN-CHK)",
      phone: "+221 77 205 17 79",
      relation: "Encadrement académique et direction de recherche Master"
    }
  ]
};
